const MODULE = 'fulcrum/containers/Form/MissionProfile/'
const MISSION_PROFILE_ADD = MODULE + 'MISSION_PROFILE_ADD'
const MISSION_PROFILE_REMOVE = MODULE + 'MISSION_PROFILE_REMOVE'
const MISSION_PROFILE_UPDATE = MODULE + 'MISSION_PROFILE_UPDATE'

const POWER_ON_ADD = MODULE + 'POWER_ON_ADD'
const POWER_ON_REMOVE = MODULE + 'POWER_ON_REMOVE'
const POWER_ON_UPDATE = MODULE + 'POWER_ON_UPDATE'

const POWER_OFF_ADD = MODULE + 'POWER_OFF_ADD'
const POWER_OFF_REMOVE = MODULE + 'POWER_OFF_REMOVE'
const POWER_OFF_UPDATE = MODULE + 'POWER_OFF_UPDATE'

export {
    MISSION_PROFILE_ADD,
    MISSION_PROFILE_REMOVE,
    MISSION_PROFILE_UPDATE,
    POWER_ON_ADD,
    POWER_ON_REMOVE,
    POWER_ON_UPDATE,
    POWER_OFF_ADD,
    POWER_OFF_REMOVE,
    POWER_OFF_UPDATE
}